<cmps-dialog>
    <div
        class="p-3"
        *ngIf="state?.pending?.initMain; else show"
    >
        <cmps-wait-status></cmps-wait-status>
    </div>
    <ng-template #show>
        <cmps-dialog-header
            #dialogHeader
            [hasExpandAction]="true"
            [collapseTooltip]="_i18n._9978_COLLAPSE | translate"
            [expandTooltip]="_i18n._9977_EXPAND | translate"
            [closeTooltip]="_i18n._763_CLOSE | translate"
            class="navbar-dark pr-3"
        >
            <h4 class="modal-title text-white m-3">
                {{ _i18n._11051_FOCUS_SELECTOR | translate }}
            </h4>
        </cmps-dialog-header>
        <cmps-dialog-body class="p-3">
            <div class="row flex-grow-1">
                <div
                    class="col-xl-9 d-flex flex-column selector-main-container"
                    [class.force-column]="_forceColumn"
                >
                    <cmps-tabset
                        [(selectedTabRefId)]="_activeTab"
                        class="flex-xl-grow-1"
                    >
                        <div class="focus-navigation">
                            <div class="card">
                                <cmps-tabset-label-wrapper>
                                    <ng-template
                                        cmpsTabLabel
                                        tabRefId="{{
                                            _NavigationTabRefs.FOCUS_HISTORY
                                        }}"
                                        let-ctx
                                    >
                                        <button
                                            cmpsTabButton
                                            [disabled]="
                                                state.triggerSource ===
                                                _TriggerSource.MANAGE_GOALS
                                            "
                                            theme="a"
                                            [selected]="ctx.selected"
                                            (click)="ctx.select()"
                                        >
                                            <span cmpsTabButtonLabel>{{
                                                _i18n._11053_FOCUS_HISTORY
                                                    | translate
                                            }}</span>
                                        </button>
                                    </ng-template>
                                    <ng-template
                                        cmpsTabLabel
                                        tabRefId="{{
                                            _NavigationTabRefs.METRIC_SELECTION
                                        }}"
                                        let-ctx
                                    >
                                        <button
                                            #metricSelection
                                            cmpsTabButton
                                            [disabled]="
                                                state.triggerSource ===
                                                _TriggerSource.MANAGE_GOALS
                                            "
                                            theme="a"
                                            [selected]="ctx.selected"
                                            (click)="ctx.select()"
                                        >
                                            <span cmpsTabButtonLabel>{{
                                                _i18n._11054_METRIC_SELECTION
                                                    | translate
                                            }}</span>
                                        </button>
                                    </ng-template>
                                    <ng-template
                                        cmpsTabLabel
                                        tabRefId="{{
                                            _NavigationTabRefs.FOCUS_SELECTION
                                        }}"
                                        let-ctx
                                    >
                                        <button
                                            #focusSelection
                                            cmpsTabButton
                                            theme="a"
                                            [disabled]="
                                                state.triggerSource ===
                                                _TriggerSource.MANAGE_GOALS
                                            "
                                            [selected]="ctx.selected"
                                            (click)="ctx.select()"
                                        >
                                            <span cmpsTabButtonLabel>{{
                                                _i18n._11055_FOCUS_SELECTION
                                                    | translate
                                            }}</span>
                                        </button>
                                    </ng-template>
                                    <ng-template
                                        *ngIf="
                                            state.triggerSource !=
                                            _TriggerSource.OBSERVATION
                                        "
                                        cmpsTabLabel
                                        tabRefId="{{
                                            _NavigationTabRefs.LOAD_GOALS
                                        }}"
                                        let-ctx
                                    >
                                        <button
                                            cmpsTabButton
                                            theme="a"
                                            [selected]="ctx.selected"
                                            (click)="ctx.select()"
                                        >
                                            <span cmpsTabButtonLabel>{{
                                                _i18n._11056_LOAD_GOALS
                                                    | translate
                                            }}</span>
                                        </button>
                                    </ng-template>
                                </cmps-tabset-label-wrapper>
                            </div>
                        </div>
                        <div class="focus-content">
                            <cmps-tabset-content-wrapper>
                                <ng-template
                                    cmpsTabContent
                                    tabRefId="{{
                                        _NavigationTabRefs.FOCUS_HISTORY
                                    }}"
                                >
                                    <cmps-focus-history
                                        [pending]="
                                            state?.pending?.initFocusHistory
                                        "
                                        [behaviours]="state.behaviours"
                                        [activeFocusesForPerformer]="
                                            state.activeFocusesForPerformer
                                        "
                                        [activeForPerformerGrid]="
                                            state.activeFocusesPerformerGrid
                                        "
                                        [closedForPerformerGrid]="
                                            state.recentlyClosedFocusesPerformerGrid
                                        "
                                        [activeForTeamGrid]="
                                            state.activeFocusesTeamGrid
                                        "
                                        [closedForTeamGrid]="
                                            state.recentlyClosedFocusesTeamGrid
                                        "
                                        (selectGridRow)="
                                            _selectFocusHistoryGridRow($event)
                                        "
                                        (sortGrid)="
                                            _sortFocusHistoryGrid($event)
                                        "
                                        (clearGridSelection)="
                                            _focusHistoryClearGrid($event)
                                        "
                                        (selectFocus)="_selectFocus($event)"
                                    ></cmps-focus-history>
                                </ng-template>
                                <ng-template
                                    cmpsTabContent
                                    tabRefId="{{
                                        _NavigationTabRefs.METRIC_SELECTION
                                    }}"
                                >
                                    <cmps-metric-selection
                                        [metrices]="state.coachableMetrics"
                                        [gridData]="state.metricSelectionGrid"
                                        (selectActiveMetric)="
                                            _selectMetric($event)
                                        "
                                        (selectMetricRow)="
                                            _selectMetricRow($event)
                                        "
                                        (sortMetricGrid)="
                                            _sortMetricGrid($event)
                                        "
                                    ></cmps-metric-selection>
                                </ng-template>
                                <ng-template
                                    cmpsTabContent
                                    tabRefId="{{
                                        _NavigationTabRefs.FOCUS_SELECTION
                                    }}"
                                >
                                    <cmps-focus-selection
                                        [activeFocusesForPerformer]="
                                            state.activeFocusesForPerformer
                                        "
                                        [activeMetric]="state.activeMetric"
                                        [gridData]="state.focusSelectionGrid"
                                        [behaviours]="state.behaviours"
                                        [selectedFocus]="state.selectedFocus"
                                        (activeFocusBannerClick)="
                                            _navigateToTab(
                                                _NavigationTabRefs.FOCUS_HISTORY
                                            )
                                        "
                                        (selectSubBehaviourRow)="
                                            _selectSubBehaviourRow($event)
                                        "
                                        (sortFocusSelectionGrid)="
                                            _sortFocusSelectionGrid($event)
                                        "
                                        (filterFocusSelectionGrid)="
                                            _filterFocusSelectionGrid($event)
                                        "
                                        (selectFocus)="_selectFocus($event)"
                                    ></cmps-focus-selection>
                                </ng-template>
                                <ng-template
                                    *ngIf="
                                        state.triggerSource !==
                                        _TriggerSource.OBSERVATION
                                    "
                                    cmpsTabContent
                                    tabRefId="{{
                                        _NavigationTabRefs.LOAD_GOALS
                                    }}"
                                >
                                    <cmps-load-goals
                                        [performerId]="state.performerId"
                                        [goalThresholds]="state.goalThresholds"
                                        [activeMetric]="state.activeMetric"
                                        [selectedFocus]="state.selectedFocus"
                                        [selectedGoals]="state.selectedGoals"
                                        [gridData]="state.loadGoalsGrid"
                                        [triggerSource]="_options.triggerSource"
                                        (selectRow)="_selectGoalRow($event)"
                                        (updateSelectedGoal)="
                                            _updateSelectedGoal($event)
                                        "
                                        (deleteSelectedGoal)="
                                            _deleteSelectedGoal($event)
                                        "
                                    ></cmps-load-goals>
                                </ng-template>
                            </cmps-tabset-content-wrapper>
                        </div>
                    </cmps-tabset>
                </div>
                <cmps-focus-selection-result
                    class="col-xl-3"
                    [dialogOptions]="_options"
                    [activeMetric]="state.activeMetric"
                    [selectedFocus]="state.selectedFocus"
                    [selectedGoals]="state.loadGoalsGrid.selection.goals"
                    [triggerSource]="_options.triggerSource"
                    (editSelectedMetric)="
                        _navigateToTab(_NavigationTabRefs.METRIC_SELECTION)
                    "
                    (deselectLoadedGoal)="_deleteSelectedGoal($event)"
                    (confirmSelection)="_focusSelectorConfirmSelection()"
                    (scrollToGoal)="_onScrollToGoal($event)"
                >
                </cmps-focus-selection-result>
            </div>
        </cmps-dialog-body>
    </ng-template>
</cmps-dialog>
